export enum CategoryEnum{
    
    MANISSUE="MAN ISSUE",
    MACHINEISSUE="MACHINE ISSUE",
    MANANDMACHINEISSUE="MAN AND MACHINE ISSUE",
    SALEORDER="SALE ORDER",
    THIRDPARTY="THIRD PARTY"

}